export default function () {
    return {
        errorMessage: {
            show: false,
            content: null,
            timeout: 5000
        },
        successMessage: {
            show: false,
            content: null,
            timeout: 5000
        }
    }
}
